import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { fromJS, List } from 'immutable';
import Helmet from 'react-helmet';

import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Panel from 'react-bootstrap/lib/Panel';

import AddSelfCredits from 'components/Project/AddCredits/AddSelfCredits';
// import Comments from 'components/Project/Comments/Comments/Comments';
import Loader from 'components/Loader/Loader';
import Modal from 'components/Modal/Modal';
import NotFoundContent from 'components/NotFoundContent/NotFoundContent';
import ProjectContent from 'components/Project/ProjectContent/ProjectContent';
import ProjectCredits from 'components/Project/ProjectCredits/ProjectCredits';
import ProjectBuyerUpsell from 'components/Project/ProjectBuyerUpsell';
import ProjectCreativeUpsell from 'components/Project/ProjectCreativeUpsell';
// import ProjectShare from 'components/Project/ProjectShare';
import ReportProject from 'components/Project/ReportProject';
// import Tab from 'components/Tabs/Tab';
// import Tabs from 'components/Tabs/Tabs';
import TimeAgo from 'components/TimeAgo/TimeAgo';
import AlertBox from 'components/AlertBox/AlertBox';
import { trackEvent } from 'helpers/Analytics';
import {
  clearProjectPublishFlash,
  consumeProjectPublishBanner,
  getProjectPublishPreview,
} from 'helpers/projectPublishFlash';
import styles from './Project.module.scss';

const PROCESSING_POLL_MS = 4000;

export default class Project extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,

    creditsEntities: PropTypes.object,
    loadingSuggestedRoles: PropTypes.bool,
    loadedSuggestedRoles: PropTypes.bool,
    loadingSuggestedSkills: PropTypes.bool,
    loadedSuggestedSkills: PropTypes.bool,
    project: PropTypes.object,
    // projectCommentsEntities: PropTypes.object,
    projectEntities: PropTypes.object,
    userEntities: PropTypes.object,
    roleEntities: PropTypes.object,
    skillEntities: PropTypes.object,
    suggestedRoles: PropTypes.array,
    suggestedSkills: PropTypes.array,

    // functions
    addCredit: PropTypes.func,
    download: PropTypes.func,
    hasLiked: PropTypes.func,
    like: PropTypes.func,
    likeComment: PropTypes.func,
    loadCommentReplies: PropTypes.func,
    loadComments: PropTypes.func,
    loadCredits: PropTypes.func,
    loadProject: PropTypes.func,
    loadCollection: PropTypes.func,
    loadRelatedProjects: PropTypes.func,
    loadSuggestedRoles: PropTypes.func,
    loadSuggestedSkills: PropTypes.func,
    postComment: PropTypes.func,
    reportComment: PropTypes.func,
    reportProject: PropTypes.func,
    setSuccessMessage: PropTypes.func,
    unLike: PropTypes.func,
    unLikeComment: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      addingCreditsStep: 0,
      clientPreviewUrl: null,
      commentReplyingIndex: -1,
      commentReplyText: '',
      commentText: '',
      reportComments: '',
      reportingComment: null,
      reportReason: null,
      selectedAddingRoles: [],
      selectedAddingUser: null,
      showAddCreditsModal: false,
      showPublishedBanner: false,
      showReportingCommentModal: false,
      showReportModal: false,
      showDownloadPendingAlert: false,
      showCollections: false,
    };

    this.processingPollTimer = null;
  }

  componentDidMount() {
    const projectHash = 'c' + this.props.match.params.hash;
    const {
      project,
      loadProject,
      loadCollection,
      loadCredits,
      loadComments,
      loadRelatedProjects,
      loadedSuggestedRoles,
      loadingSuggestedRoles,
      loadSuggestedRoles,
      loadedSuggestedSkills,
      loadingSuggestedSkills,
      loadSuggestedSkills,
      match,
      hasLiked,
    } = this.props;
    // Load project if we haven't already
    if (
      !project.getIn([projectHash, 'loadedProject'], null) &&
      !project.getIn([projectHash, 'loadingProject'], null)
    ) {
      loadProject(projectHash);
    }

    if (
      !project.getIn([projectHash, 'loadedCollection'], null) &&
      !project.getIn([projectHash, 'loadingCollection'], null)
    ) {
      loadCollection(projectHash);
    }

    if (
      !project.getIn([projectHash, 'loadedCredits'], null) &&
      !project.getIn([projectHash, 'loadingCredits'], null)
    ) {
      loadCredits(projectHash);
    }

    if (
      !project.getIn([projectHash, 'loadedComments'], null) &&
      !project.getIn([projectHash, 'loadingComments'], null)
    ) {
      loadComments(projectHash);
    }

    if (
      !project.getIn([projectHash, 'loadedRelatedProjects'], null) &&
      !project.getIn([projectHash, 'loadingRelatedProjects'], null)
    ) {
      loadRelatedProjects(projectHash, 5);
    }

    if (!loadedSuggestedRoles && !loadingSuggestedRoles) {
      loadSuggestedRoles();
    }

    if (!loadedSuggestedSkills && !loadingSuggestedSkills) {
      loadSuggestedSkills();
    }

    // Load like state if we haven't already
    if (
      this.props.user &&
      this.props.user.username !== match.params.username &&
      !project.hasIn([projectHash, 'hasLiked']) &&
      !project.getIn([projectHash, 'loadingLikeState'], false)
    ) {
      hasLiked(projectHash);
    }

    if (this.props.user && this.props.user.type === 'buyer') {
      trackEvent('users-lands-on-portfolio-project');
    }

    this.hydratePublishFlash();
    this.syncProcessingPoll();
  }

  componentDidUpdate(prevProps) {
    const projectHash = 'c' + this.props.match.params.hash;

    if (
      prevProps.project.getIn([projectHash, 'postingCredit']) &&
      !this.props.project.getIn([projectHash, 'postingCredit']) &&
      this.props.project.getIn([projectHash, 'postedCredit'])
    ) {
      this.props.setSuccessMessage('Credit Requested');
    }

    const prevId = this.getProjectObj(prevProps)?.id;
    const nextId = this.getProjectObj(this.props)?.id;
    if (prevId !== nextId) {
      this.hydratePublishFlash();
    }

    this.syncProcessingPoll();
  }

  componentWillUnmount() {
    this.clearProcessingPoll();
  }

  getProjectObj = (props = this.props) => {
    const projectHash = 'c' + props.match.params.hash;
    const projectId = props.project.getIn([projectHash, 'id']);
    if (!projectId) {
      return null;
    }

    const entity = props.projectEntities.get(projectId.toString(), null);
    return entity ? entity.toJS() : null;
  };

  hydratePublishFlash = () => {
    const projectObj = this.getProjectObj();
    if (!projectObj?.id || typeof window === 'undefined') {
      return;
    }

    const showBanner = consumeProjectPublishBanner(projectObj.id);
    const previewUrl = getProjectPublishPreview(projectObj.id);

    this.setState({
      showPublishedBanner: showBanner,
      clientPreviewUrl: previewUrl,
    });

    if (projectObj.state !== 'processing' && previewUrl) {
      clearProjectPublishFlash(projectObj.id);
      this.setState({ clientPreviewUrl: null });
    }
  };

  clearProcessingPoll = () => {
    if (this.processingPollTimer) {
      clearInterval(this.processingPollTimer);
      this.processingPollTimer = null;
    }
  };

  syncProcessingPoll = () => {
    const projectObj = this.getProjectObj();
    const projectHash = 'c' + this.props.match.params.hash;
    const isProcessing = projectObj?.state === 'processing';

    if (!isProcessing) {
      this.clearProcessingPoll();
      if (projectObj?.id && this.state.clientPreviewUrl) {
        clearProjectPublishFlash(projectObj.id);
        if (this.state.clientPreviewUrl) {
          this.setState({ clientPreviewUrl: null });
        }
      }
      return;
    }

    if (this.processingPollTimer || typeof window === 'undefined') {
      return;
    }

    this.processingPollTimer = setInterval(() => {
      if (this.props.loadProject) {
        this.props.loadProject(projectHash);
      }
    }, PROCESSING_POLL_MS);
  };

  checkSignin = () => {
    const projectHash = 'c' + this.props.match.params.hash;

    if (!this.props.user) {
      const projectId = this.props.project.getIn([projectHash, 'id']);
      const projectObj = projectId
        ? this.props.projectEntities.get(projectId.toString(), null).toJS()
        : null;

      document.location = '/signin?referrer=' + projectObj.links.main;

      return false;
    }

    return true;
  };

  handleAddingCredit = () => {
    if (!this.checkSignin()) {
      return;
    }

    this.setState({
      addingCreditsStep: 1,
      showAddCreditsModal: true,
      selectedAddingRoles: [],
      selectedAddingUser: null,
    });
  };

  handleAddSelectedRole = (selectedRoles) => {
    this.setState({
      selectedAddingRoles: selectedRoles,
    });
  };

  handleComment = (replyTo = null) => {
    if (!this.checkSignin()) {
      return;
    }

    const projectHash = 'c' + this.props.match.params.hash;

    this.props
      .postComment(
        projectHash,
        replyTo === null ? this.state.commentText : this.state.commentReplyText,
        replyTo === null
          ? null
          : replyTo.parent_id
          ? replyTo.parent_id
          : replyTo.id
      )
      .then(
        () => {
          this.setState({
            commentText: '',
            commentReplyingIndex: -1,
            commentReplyText: '',
          });
        },
        () => {
          // ignore
        }
      );
  };

  handleToggleCommentLike = (comment) => {
    if (!this.checkSignin()) {
      return;
    }

    const projectHash = 'c' + this.props.match.params.hash;

    if (comment.parent_id) {
      if (
        this.props.project.getIn(
          [
            projectHash,
            'commentReplies',
            comment.parent_id.toString(),
            'commentStats',
            comment.id.toString(),
            'hasLiked',
          ],
          false
        )
      ) {
        this.props.unLikeComment(projectHash, comment);
      } else {
        this.props.likeComment(projectHash, comment);
      }

      return;
    }

    if (
      this.props.project.getIn(
        [projectHash, 'commentStats', comment.id.toString(), 'hasLiked'],
        false
      )
    ) {
      this.props.unLikeComment(projectHash, comment);
    } else {
      this.props.likeComment(projectHash, comment);
    }
  };

  handleCommentReplying = (comment) => {
    if (!this.checkSignin()) {
      return;
    }

    this.setState({
      commentReplyingIndex: comment.id,
      commentReplyText: this.props.user
        ? '@' + comment.user.username + ' '
        : '',
    });
  };

  handleCommentReplyText = (comment) => {
    this.setState({
      commentReplyText: comment,
    });
  };

  handleCommentReporting = (comment) => {
    if (!this.checkSignin()) {
      return;
    }

    this.setState({
      showReportingCommentModal: true,
      reportingComment: comment,
    });
  };

  handleCommentReport = () => {
    if (!this.checkSignin()) {
      return;
    }

    this.setState({
      showReportingCommentModal: false,
      reportingComment: null,
    });

    const projectHash = 'c' + this.props.match.params.hash;

    if (this.state.reportingComment.parent_id) {
      if (
        !this.props.project.getIn(
          [
            projectHash,
            'commentReplies',
            this.state.reportingComment.parent_id.toString(),
            'commentStats',
            this.state.reportingComment.id.toString(),
            'hasReported',
          ],
          false
        )
      ) {
        this.props.reportComment(projectHash, this.state.reportingComment);
      } else {
        alert('You have already reported this comment.');
      }

      return;
    }

    if (
      !this.props.project.getIn(
        [
          projectHash,
          'commentStats',
          this.state.reportingComment.id.toString(),
          'hasReported',
        ],
        false
      )
    ) {
      this.props.reportComment(projectHash, this.state.reportingComment);
    } else {
      alert('You have already reported this comment.');
    }
  };

  handleCommentText = (comment) => {
    this.setState({
      commentText: comment,
    });
  };

  handleDownload = () => {
    if (!this.checkSignin()) {
      return;
    }

    const projectHash = 'c' + this.props.match.params.hash;

    if (!this.props.project.getIn([projectHash, 'downloadUrl'], false)) {
      this.props.download('c' + this.props.match.params.hash).then(() => {
        if (
          this.props.project.getIn([projectHash, 'requested'], false) &&
          !this.props.project.getIn([projectHash, 'downloadUrl'], false)
        ) {
          this.setState({ showDownloadPendingAlert: true });
        } else {
          document.location = this.props.project.getIn(
            [projectHash, 'downloadUrl'],
            ''
          );
        }
      });
    } else {
      document.location = this.props.project.getIn(
        [projectHash, 'downloadUrl'],
        ''
      );
    }
  };

  handleReport = (reason, comment) => {
    const projectHash = 'c' + this.props.match.params.hash;

    this.props.reportProject(projectHash, reason, comment);

    this.setState({
      reportComments: '',
      reportReason: null,
      showReportModal: false,
    });
  };

  handleRequestSelectedRoles = () => {
    if (this.state.selectedAddingRoles.length <= 0) {
      return;
    }

    const projectHash = 'c' + this.props.match.params.hash;
    const projectId = this.props.project.getIn([projectHash, 'id']);

    this.props.addCredit(
      projectHash,
      projectId,
      this.state.selectedAddingUser === null
        ? this.props.user.id
        : this.state.selectedAddingUser.value.id,
      this.state.selectedAddingRoles.map((role) => role.value)
    );

    this.setState({
      addingCreditsStep: Math.floor(this.state.addingCreditsStep) + 1,
      selectedAddingRoles: [],
      selectedAddingUser: null,
    });
  };

  handleToggleLike = () => {
    if (!this.checkSignin()) {
      return;
    }

    const projectHash = 'c' + this.props.match.params.hash;

    const projectId = this.props.project.getIn([projectHash, 'id']);
    const projectObj = projectId
      ? this.props.projectEntities.get(projectId.toString(), null).toJS()
      : null;

    // user can not like own project
    if (this.props.user.id === projectObj.user_id) {
      return;
    }

    if (this.props.project.getIn([projectHash, 'hasLiked'], false)) {
      this.props.unLike(projectHash);
    } else {
      this.props.like(projectHash);
    }
  };

  render() {
    const {
      user,
      creditsEntities,
      loadingSuggestedRoles,
      location,
      match: { params },
      project,
      // projectCommentsEntities,
      projectEntities,
      suggestedRoles,
      suggestedSkills,
      userEntities,
      roleEntities,
      skillEntities,
    } = this.props;

    const {
      addingCreditsStep,
      // commentText,
      // commentReplyingIndex,
      // commentReplyText,
      selectedAddingRoles,
      showAddCreditsModal,
      showPublishedBanner,
      showReportingCommentModal,
      showReportModal,
      showDownloadPendingAlert,
      reportComments,
      reportReason,
      showCollections,
      clientPreviewUrl,
    } = this.state;

    const username = params.username;
    const projectHash = 'c' + params.hash;
    const projectId = project.getIn([projectHash, 'id']);
    const projectObj = projectId
      ? projectEntities.get(projectId.toString(), null).toJS()
      : null;
    const projectOwner = projectObj
      ? userEntities.get(projectObj.user.toString(), null).toJS()
      : null;

    if (
      !projectObj &&
      this.props.project[projectHash] &&
      !this.props.project[projectHash].loadedProject
    ) {
      return (
        <div className="mt++ text-center">
          <Loader loading />
        </div>
      );
    }

    const title =
      (projectObj
        ? `${projectObj.title} by ${
            projectOwner ? projectOwner.displayname : username
          }`
        : `Project by ${username}`) + ' - on Twine.';
    const description =
      projectObj && projectObj.description !== ''
        ? projectObj.description
        : title;

    if (
      !isNaN(username) ||
      (this.props.project[projectHash] &&
        this.props.project[projectHash].loadedProject &&
        !projectObj)
    ) {
      return <NotFoundContent />;
    }

    if (projectObj) {
      if (
        projectObj.state === 'deleted' ||
        projectObj.state === 'disabled' ||
        projectObj.state === 'inactive'
      ) {
        return <NotFoundContent />;
      }

      if (projectObj.state === 'banned' || projectObj.state === 'copyright') {
        return (
          <NotFoundContent
            title={`It looks like ${projectOwner.username} project has been removed.`}
            subtitle={
              <div className="text-center" style={{ color: 'white' }}>
                <p className="fs-20">
                  Uploaded <TimeAgo timestamp={projectObj.created_at} />
                </p>
                <p className="fs-20">
                  Removed <TimeAgo timestamp={projectObj.updated_at} />
                </p>
                <p className="fs-26 mt- mb+">
                  Get quality creative freelancers to help you grow on Twine
                </p>
              </div>
            }
            status404={false}
          />
        );
      }
    }
    const creditsWithRoleNames = project
      .getIn([projectHash, 'credits'], List())
      .map((creditId) => {
        const credit = creditsEntities.get(creditId.toString()).toJS();
        credit.user = userEntities.get(credit.user_id.toString()).toJS();
        credit.roles = credit.roles.map(
          (role) => roleEntities.getIn([role.toString()]).toJS().name
        );
        return fromJS(credit);
      })
      .toJS();

    const projectCredits = (
      <ProjectCredits
        credits={creditsWithRoleNames}
        loggedInUser={user}
        creditsTotal={project.getIn([projectHash, 'creditsTotal'], 0)}
        loadingCredits={project.getIn([projectHash, 'loadingCredits'], false)}
        onLoadMore={() => {
          if (project.getIn([projectHash, 'moreCredits'], false)) {
            this.props.loadCredits(
              projectHash,
              project.getIn([projectHash, 'creditsPagesLoaded'], 0) + 1
            );
          }
        }}
        more={project.getIn([projectHash, 'moreCredits'], false)}
        owner={projectOwner}
        onAddCredit={this.handleAddingCredit}
      />
    );

    return (
      <div className="mt++ font-regular">
        <Helmet
          title={title}
          link={[
            { rel: 'canonical', href: projectObj ? projectObj.links.main : '' },
          ]}
          meta={[
            { property: 'og:title', content: title },
            { name: 'twitter:title', content: title },
            { name: 'description', content: description },
            { property: 'og:description', content: description },
            { name: 'twitter:description', content: description },
            {
              property: 'og:url',
              content: projectObj ? projectObj.links.main : '',
            },
            {
              property: 'og:image',
              content:
                projectObj &&
                typeof projectObj.thumbnails.images['405'] !== 'undefined'
                  ? projectObj.thumbnails.images['405'].square.main
                  : '',
            },
            {
              name: 'twitter:image',
              content:
                projectObj &&
                typeof projectObj.thumbnails.images['405'] !== 'undefined'
                  ? projectObj.thumbnails.images['405'].square.main
                  : '',
            },
          ]}
        />
        {params.credits ? (
          <Grid>
            <Col xs={12} md={9}>
              <Row>{projectCredits}</Row>
            </Col>
          </Grid>
        ) : (
          <div>
            <Grid>
              <Col xs={12} md={9} className={styles.paddingRightMd}>
                <Row>
                  <Panel className={styles.projectPanel}>
                    <ProjectContent
                      clientPreviewUrl={clientPreviewUrl}
                      showPublishedBanner={showPublishedBanner}
                      onDismissPublishedBanner={() =>
                        this.setState({ showPublishedBanner: false })
                      }
                      collection={project
                        .getIn([projectHash, 'collection'], List())
                        .map((projectId) => {
                          const collectionProject = projectEntities
                            .get(projectId.toString())
                            .toJS();
                          collectionProject.user = userEntities
                            .get(collectionProject.user_id.toString())
                            .toJS();

                          return fromJS(collectionProject);
                        })
                        .toJS()}
                      collectionTotal={project.getIn(
                        [projectHash, 'collectionTotal'],
                        0
                      )}
                      loadingCollection={this.props.project.getIn(
                        [projectHash, 'loadingCollection'],
                        null
                      )}
                      credits={project
                        .getIn([projectHash, 'credits'], List())
                        .map((creditId) => {
                          const credit = creditsEntities
                            .get(creditId.toString())
                            .toJS();
                          credit.user = userEntities
                            .get(credit.user_id.toString())
                            .toJS();

                          return fromJS(credit);
                        })
                        .toJS()}
                      creditsLink={`${location.pathname}/credits`}
                      creditsTotal={project.getIn(
                        [projectHash, 'creditsTotal'],
                        0
                      )}
                      likeState={project.getIn(
                        [projectHash, 'hasLiked'],
                        false
                      )}
                      likesTotal={project.getIn([projectHash, 'likesTotal'], 0)}
                      loggedInUser={user}
                      hasReported={project.getIn(
                        [projectHash, 'hasReported'],
                        false
                      )}
                      onDownload={() => this.handleDownload()}
                      onReport={() => this.setState({ showReportModal: true })}
                      onLoadMoreCollection={() => {
                        if (
                          project.getIn([projectHash, 'moreCollection'], false)
                        ) {
                          this.props.loadCollection(
                            projectHash,
                            project.getIn(
                              [projectHash, 'collectionPagesLoaded'],
                              0
                            ) + 1
                          );
                        }
                      }}
                      owner={projectOwner}
                      project={projectObj}
                      suggestedRoles={suggestedRoles.map((role) =>
                        roleEntities.getIn([role.toString()]).toJS()
                      )}
                      suggestedSkills={suggestedSkills.map((skill) =>
                        skillEntities.getIn([skill.toString()]).toJS()
                      )}
                      toggleLike={() => this.handleToggleLike()}
                      showCollections={showCollections}
                      onShowCollections={(projectId) =>
                        this.setState({ showCollections: projectId })
                      }
                    />
                  </Panel>
                </Row>
              </Col>
              <Col xs={12} md={3} className={styles.paddingLeftMd}>
                <Row>{projectCredits}</Row>
                {!user &&
                  project.getIn([projectHash, 'loadedCredits'], false) &&
                  this.props.loadedSuggestedRoles && (
                    <Row>
                      <ProjectCreativeUpsell
                        project={projectObj}
                        credits={creditsWithRoleNames}
                        suggestedRoles={suggestedRoles.map((role) =>
                          roleEntities.getIn([role.toString()]).toJS()
                        )}
                      />
                    </Row>
                  )}
                {!user &&
                  this.props.loadedSuggestedRoles &&
                  this.props.loadedSuggestedSkills && (
                    <Row>
                      <ProjectBuyerUpsell
                        project={projectObj}
                        suggestedRoles={suggestedRoles.map((role) =>
                          roleEntities.getIn([role.toString()]).toJS()
                        )}
                        suggestedSkills={suggestedSkills.map((skill) =>
                          skillEntities.getIn([skill.toString()]).toJS()
                        )}
                      />
                    </Row>
                  )}
              </Col>
            </Grid>
            <Modal
              show={showReportingCommentModal}
              onExit={() =>
                this.setState({
                  showReportingCommentModal: false,
                  reportingComment: null,
                })
              }
            >
              <p style={{ textAlign: 'center', fontSize: '200%' }}>
                <strong>Are you sure?</strong>
              </p>
              <p style={{ textAlign: 'center', fontSize: '130%' }}>
                Are you sure you want to report this comment?
              </p>
              <p style={{ textAlign: 'center' }} className="mt">
                <Button
                  style={{ marginRight: 50 }}
                  bsSize="lg"
                  bsStyle="info"
                  onClick={() =>
                    this.setState({
                      showReportingCommentModal: false,
                      reportingComment: null,
                    })
                  }
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginLeft: 50 }}
                  bsSize="lg"
                  bsStyle="danger"
                  onClick={this.handleCommentReport}
                >
                  Yes, report it
                </Button>
              </p>
            </Modal>
            <Modal
              show={showReportModal}
              onExit={() =>
                this.setState({
                  showReportModal: false,
                  reportComments: '',
                  reportReason: null,
                })
              }
            >
              <ReportProject
                onChangeReportComments={(comment) =>
                  this.setState({ reportComments: comment })
                }
                onChangeReportReason={(reason) =>
                  this.setState({ reportReason: reason })
                }
                onReport={(reason, comment) =>
                  this.handleReport(reason, comment)
                }
                reportComments={reportComments}
                reportReason={reportReason}
              />
            </Modal>
            <Modal
              show={showAddCreditsModal}
              onExit={() =>
                this.setState({
                  showAddCreditsModal: false,
                  addingCreditsStep: 0,
                  selectedAddingRoles: [],
                  selectedAddingUser: null,
                })
              }
              closeButton
              title="Did you work on this?"
            >
              <h5 className="mb fs-16" style={{ color: '#1088f2' }}>
                Credits:
              </h5>
              <p className="mb">
                List all the people who worked or helped out on this project.
                Select a role for each person by choosing from our list. For
                more info see our{' '}
                <a href="https://help.twine.net/en/category/freelancers-1pt5jzn/">
                  help
                </a>
                .
              </p>
              {addingCreditsStep <= 1 && (
                <AddSelfCredits
                  handleRequestCredits={this.handleRequestSelectedRoles.bind(
                    this
                  )}
                  handleRoleSelected={this.handleAddSelectedRole}
                  handelSkip={() =>
                    this.setState({
                      addingCreditsStep: 1.5,
                      selectedAddingRoles: [],
                      selectedAddingUser: null,
                    })
                  }
                  loadingRoles={loadingSuggestedRoles}
                  roles={suggestedRoles.map((role) =>
                    roleEntities.getIn([role.toString()]).toJS()
                  )}
                  selectedRoles={selectedAddingRoles}
                />
              )}
              <p
                className="fs-12 mt"
                style={{ marginBottom: '-6px', color: 'gray' }}
              >
                *Please note credit requests will have to be reviewed by all
                parties involved.
              </p>
            </Modal>
          </div>
        )}
        <AlertBox
          show={showDownloadPendingAlert}
          onConfirm={() => this.setState({ showDownloadPendingAlert: false })}
          title="Your download will be ready soon."
          text={
            <p>
              We will send you an email with a link to your file download.
              <br />
              <br />
              Please allow an hour for the link to be generated. If you have not
              received it within the hour, please contact support.
            </p>
          }
          icon="info"
          theme="info"
        />
      </div>
    );
  }
}
